class CustomAccordion {
  constructor(container) {
    this.accordions = container.querySelectorAll("[data-accordion-item]");
    this.init();
  }

  init() {
    this.accordions.forEach((accordion) => {
      const header = accordion.querySelector(".custom-accordion__header");
      header.addEventListener("click", () => this.toggleAccordion(accordion));
    });
  }

  toggleAccordion(accordion) {
    const isActive = accordion.hasAttribute("data-active");

    if (isActive) {
      accordion.removeAttribute("data-active");
      accordion
        .querySelector(".custom-accordion__header")
        .setAttribute("aria-expanded", "false");
    } else {
      // Close others if you want single-open behavior
      this.accordions.forEach((item) => {
        item.removeAttribute("data-active");
        item
          .querySelector(".custom-accordion__header")
          .setAttribute("aria-expanded", "false");
      });

      accordion.setAttribute("data-active", "");
      accordion
        .querySelector(".custom-accordion__header")
        .setAttribute("aria-expanded", "true");
    }
  }
}

// Initialize
// document.querySelectorAll(".custom-accordion").forEach((container) => {
//   new CustomAccordion(container);
// });

/* 
<div class="custom-accordion">
  <div class="custom-accordion__item" data-accordion-item>
    <button class="custom-accordion__header" aria-expanded="false">
      <!-- Can put any HTML here -->
      <div class="header-content">
        <h3>Your Title</h3>
        <svg class="accordion-icon" viewBox="0 0 24 24" width="20">
          <path d="M7 10l5 5 5-5z" fill="currentColor"/>
        </svg>
      </div>
    </button>
    
    <div class="custom-accordion__content">
      <!-- Can put any HTML here -->
      <div class="content-wrapper">
        <p>Your content</p>
        <img src="example.jpg" alt="">
      </div>
    </div>
  </div>
</div>
*/
